import { render, staticRenderFns } from "./TabelaPrecoListagem.vue?vue&type=template&id=1b034cc9&"
import script from "./TabelaPrecoListagem.vue?vue&type=script&lang=js&"
export * from "./TabelaPrecoListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports